
import {
  ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit
} from '@angular/core';
import { select, Store } from '@ngrx/store';
import { AngularTokenService } from '@raysuelzer/angular-token';
import { takeUntil } from 'rxjs/operators';

import { selectRouteData } from 'app/_state/router/router-selectors';
import { WithDisposableSubject } from 'core/mixins/with-disposable-subject';
import { getSafe } from 'helpers';

type HeaderType = 'admin' | 'campaign' | 'no_tabs';

/**
 * This is the root component when a user is logged in.
 */
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HomeComponent extends WithDisposableSubject() implements OnInit, OnDestroy {
  // Which header to display
  headerType: HeaderType;

  hideFooter = false;

  /**
   * Used to prevent the page from loading
   * before a the token service has had a chance
   * to set the current user data.
   */
  get isUserDataSet() {
    return getSafe(() => !!this.angularTokenService.currentUserData, false);
  }

  constructor(
    private cd: ChangeDetectorRef,
    private angularTokenService: AngularTokenService,
    private store: Store
  ) {
    super();
  }

  ngOnInit() {
    this.store.pipe(
      select(selectRouteData),
      takeUntil(this.disposer)
    )
      .subscribe((routeData) => {
        this.headerType = routeData?.layout?.headerType || 'campaign';
        this.hideFooter = routeData?.layout?.hideFooter || false;
        this.cd.markForCheck();
      });
  }
}
